import React, { ReactNode } from 'react';
import { AppEvent, LoggingContext } from './logging';

interface LoggingProviderProps {
  children: ReactNode;
}

// LoggerProvider component
export const LoggingProvider: React.FC<LoggingProviderProps> = ({ children }) => {
  const log = (message: string, ...optionalParams: unknown[]) => {
    console.log(`[App Log]: ${message}`, ...optionalParams);
  };

  const error = (message: string, ...optionalParams: unknown[]) => {
    console.error(`[App Log]: ${message}`, ...optionalParams);
  };

  const event = (appEvent: AppEvent) => {
    console.log(`[App Log Event] Type: ${appEvent.type} Value: ${appEvent.value} Message: ${appEvent.message} Detail: ${appEvent.detail}`);
  };

  return <LoggingContext.Provider value={{ log, error, event }}>{children}</LoggingContext.Provider>;
};
